import { useNavigate } from 'react-router';
import { Icon, IconRail, Tooltip, icons } from '@agentisai/design-system';

/**
 * The staff-only rail entry to the Evals page (ADR-0072). A navigation, not a
 * panel disclosure — so `aria-expanded` (which `IconRail.Button` sets for its
 * disclosures) is cleared. The caller renders it only for `evals:read`; the
 * page's API calls re-check the grant server-side.
 */
export function EvalsRailLink() {
  const navigate = useNavigate();
  return (
    <Tooltip content="Agent evals">
      <IconRail.Button
        aria-label="Agent evals"
        aria-expanded={undefined}
        icon={<Icon as={icons.ShieldCheck} size={20} />}
        onClick={() => void navigate('/evals')}
      />
    </Tooltip>
  );
}
EvalsRailLink.displayName = 'EvalsRailLink';
